import axios from 'axios';
import { ErrorType, UserType } from './ActionType';
import AppConfig from '../config';

const API_URL = AppConfig.API_URL;

export const getUsers = () => {
  return function (dispatch) {
    return axios.get(`${API_URL}/users/users`)
      .then((res) => {
        dispatch({ type: UserType.GET_ALL_USERS, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getUser = (token) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/users`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getToken = (token, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/tokens/${token}`)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        callback({});
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const checkDuplicateEmail = (email, callback, column) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/users/checkemail/${email}`)
      .then((res) => {
        callback(res.data, column)
        // dispatch({ type: UserType.ALL_USERS, payload: res.data });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const login = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/users/login`, data)
      .then((res) => {
        callback(res.data);
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createUser = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/users`, data)
      .then((res) => {
        callback(res.data)
        // dispatch({ type: UserType.CREATE_USERS, payload: res.data });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const deleteUser = (id, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/Login/users/${id}`)
      .then((res) => {
        dispatch({ type: UserType.DELETE_USERS, payload: res.data });
        callback(res);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUser = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/users/${id}`, data)
      .then((res) => {
        callback()
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUserById = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/users/updateUser/${id}`, data)
      .then((res) => {
        callback(res.data)
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const resetPasswordUser = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/users/resetPassword/${id}`, data)
      .then((res) => {
        callback(res.data)
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updatePassword = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/users/updatepassword/${id}`, data)
      .then((res) => {
        callback(res.data)
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const forgotPassword = (email, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/users/forgotpassword/${email}`)
      .then((res) => {
        callback(res.data);
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateToken = (id) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/tokens/${id}`, {})
      .then((res) => {
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateTokenForgotPassword = (id) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/tokens/password/${id}`, {})
      .then((res) => {
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAllTranslations = (lang) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/translations/`)
      .then((res) => {
        if(res.data.length > 0){
          dispatch({ type: UserType.GET_TRANSLATION, payload: res.data[0].translation || {} });
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getTranslations = (lang) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/translations/${lang}`)
      .then((res) => {
        dispatch({ type: UserType.GET_TRANSLATION, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updatedTranslations = (id, data) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/translations/${id}`, data)
      .then((res) => {
        if(res.data.length > 0){
          dispatch({ type: UserType.GET_TRANSLATION, payload: res.data[0].translation });
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const changeLanguage = (data) => {
  return function (dispatch) {
    dispatch({ type: UserType.CHANGE_LANGUAGE, payload: data });
  };
};

export const getAudit = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/profileAudit`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getUsersForAdmin = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/users/users`)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getDoctorsForAdmin = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors`)
      .then((res) => {
        callback(res.data)
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const cogitatioAdminLogin = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/admin/login`, data)
      .then((res) => {
        callback(res.data);
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getNotifications = (id) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/notifications/${id}`)
      .then((res) => {
        dispatch({ type: UserType.GET_NOTIFICATIONS, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateNotifications = (id) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/notifications/update/${id}`)
      .then((res) => {
        dispatch({ type: UserType.GET_NOTIFICATIONS, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postFeedback = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/feedback`, data)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getFeedbacks = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/feedback`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getActiveDataRequestUser = (business, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/activeRequest/${business}/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getInActiveDataRequestUser = (business, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/inActiveRequest/${business}/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAllBusinessForUser = (business, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/userMapping/allBusiness/${business}/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateDataRequest = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/patientDataRequest/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Request Approved')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createDataRequestUser = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/patientDataRequest/createPatientRequest`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Request added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const sendBusinessRequestToken = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/tokens/sendRequestToken`, data)
      .then((res) => {
        if (res) {
          callback(res.data, 'Request added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const addRequest = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/tokens/addRequest`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Request added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


// WEBPACK FOOTER //
// ./actions/UserActions.js